import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Hidden component for screen reader announcements
 * Creates an aria-live region for dynamic content announcements
 */
@Component({
  selector: 'app-sr-announcer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div 
      id="sr-announcer" 
      class="sr-only" 
      role="status"
      aria-live="polite"
      aria-atomic="true">
    </div>
  `,
  styles: [`
    .sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border-width: 0;
    }
  `]
})
export class SrAnnouncerComponent {}

